export default __webpack_public_path__ + "static/booze-69f3544bb58f7d540765d59733f181e0.jpg";